import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router';
import PageLoader from '../../../../Themes/Layout/PageLoader';
import { Breadcrumbs } from '../../../../Themes/Components/AbstractElements';
import TrackingEmbarquesService from '../../../../Services/Tracking/TrackingEmbarquesService';
import EmbarqueDetalhes from './components/embarqueDetalhes';

const TrackingEmbarquesView = () => {
  const [embarque, setEmbarque] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const view = async () => {
      try {
        const data = await TrackingEmbarquesService.view(id);

        setEmbarque(data);
        setLoading(false);
      } catch (error) {
        toast.error(error.message);
        navigate('/tracking/embarques');
      }
    };

    view();
  }, [id]);

  return (
    <>
      <PageLoader loaded={loading} />
      <Breadcrumbs
        mainTitle={`Embarques ${embarque?.nome ?? ''}`}
        title='Embarques'
        parent='Tracking'
        model={'Tracking.Embarques'}
        processoId={id}
        favorito={embarque?.favorito ?? false}
      />

      <div className='container-fluid'>
        <EmbarqueDetalhes embarque={embarque} />
      </div>
    </>
  );
};

export default TrackingEmbarquesView;
